import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'primereact/tooltip';
import classes from './StatCard.module.css';

import allSitesIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/home.png';
import OnlineIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/online.png';
import activeIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/activeSidebar.png';
import inactiveIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/inactiveSidebar.png';
import sitesOnSchedule from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/schedule.png';
import liveViewIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/liveView.png';
import usersIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/user.png';
import groupsIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/groups.png';
import controllerIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/controller.png';
import OfflineIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/offline.png';
import padlockIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/locks.png';
import keyBoxesIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/keybox.png';
import sensorIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/sensor.png';
import gatewayIconG from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gatewayLogoPortalG.png';
import cctvType from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cctvType.png';
import ajaxIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ajaxLogoPortal.png';
import dahuaIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dahuaLogoPortal.png';
import hikIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hikLogoPortal.png';
import aiboxIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/aiBoxLogoPortal.png';
import unstableCCTV from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/unstable_cctv.png';
import signalLostIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_lost_warning.png';
import billable from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/billedTo.png';
import criticalBatteryIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/critical-battery.png';
import warningBatteryIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/warning-battery.png';
import healthyBatteryIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/healthy-battery.png';
import unlinkedIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/unlinked.png';
import schedule from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/scheduleIcon.png';
import arm from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/armIcon.png';
import disarm from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/disarmIcon.png';
import success from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/successIcon.png';

const ICON_MAP = {
    'All sites': allSitesIcon,
    'Total sites': allSitesIcon,
    'Online sites': OnlineIcon,
    'Active sites': activeIcon,
    'Inactive sites': inactiveIcon,
    'Sites on schedule': sitesOnSchedule,
    'Live view enabled sites': liveViewIcon,
    'Users': usersIcon,
    'Groups': groupsIcon,
    'iONs': controllerIcon,
    'Total iONs': controllerIcon,
    "iON's": controllerIcon,
    'Controllers': controllerIcon,
    'All iON count': controllerIcon,
    'Online iONs': OnlineIcon,
    'Offline controllers': OfflineIcon,
    "Offline iON's": OfflineIcon,
    "Total offline iON's": OfflineIcon,
    "Total offline iON's": OfflineIcon,
    "Offline for more than 1 month": OfflineIcon,
    "Offline for less than 1 month": OfflineIcon,
    "Active offline iON's": activeIcon,
    "iONs with no users": usersIcon,
    'Active schedule only sites': sitesOnSchedule,
    'Total live view enabled sites': liveViewIcon,
    'With a camera linked': cctvType,
    'Total linked cameras': cctvType,
    'Padlocks': padlockIcon,
    'Keyboxes': keyBoxesIcon,
    'Sensors': sensorIcon,
    'Gateways': gatewayIconG,
    'Total integrations': cctvType,
    'AJAX': ajaxIcon,
    'Dahua': dahuaIcon,
    'Hikvision': hikIcon,
    'AIBox': aiboxIcon,
    'Unstable CCTV connections': unstableCCTV,
    'Offline AJAX': ajaxIcon,
    'Offline Hikvision': hikIcon,
    'Offline Dahua': dahuaIcon,
    'Offline AIBox': aiboxIcon,
    'Billable sites': billable,
    'CCTV sites': billable,
    'Billable padlocks': billable,
    'Billable keyboxes': billable,
    'Billable gateways': billable,
    'Billable sensors': billable,
    'Non-billable padlocks': inactiveIcon,
    'Unlinked padlocks': unlinkedIcon,
    'Padlocks on active sites': activeIcon,
    'Critical (<5% battery)': criticalBatteryIcon,
    'Warning (<20% battery)': warningBatteryIcon,
    'Healthy (>20% battery)': healthyBatteryIcon,
    'Non-billable keyboxes': inactiveIcon,
    'Unlinked keyboxes': unlinkedIcon,
    'Keyboxes on active sites': activeIcon,
    'Critical keyboxes (<5% battery)': criticalBatteryIcon,
    'Warning keyboxes (<20% battery)': warningBatteryIcon,
    'Healthy keyboxes (>20% battery)': healthyBatteryIcon,
    'Linked sensors': OnlineIcon,
    'Unlinked sensors': unlinkedIcon,
    'Total sites on schedule': sitesOnSchedule,
    'with temporary schedules': sitesOnSchedule,
    'Scheduled sites': sitesOnSchedule,
    'Total active users': usersIcon,
    'Total groups': groupsIcon,
    'Offline gateways': OfflineIcon,
    'Check-in missed': signalLostIcon,
    'Non-billable gateways': inactiveIcon,
    'Critical gateways (<10% battery)': criticalBatteryIcon,
    'Warning gateways (<30% battery)': warningBatteryIcon,
    'Healthy gateways (>30% battery)': healthyBatteryIcon,
    'Schedule events': schedule,
    'Successful triggers': arm,
    'Failed triggers': disarm,
    'Success rate': success,
};

const NAV_MAP = {
    'All sites': '/Dashboard/AllSites',
    'Total sites': '/Dashboard/AllSites',
    'Online sites': '/Dashboard/AllSites',
    'Active sites': '/Dashboard/ActiveSites',
    'Inactive sites': '/Dashboard/InactiveSites',
    'Users': '/Dashboard/Users',
    'Padlocks': '/Dashboard/Padlocks',
    'Keyboxes': '/Dashboard/Keyboxes',
    'Sensors': '/Dashboard/Sensors',
    'Gateways': '/Dashboard/Gateways',
    'Groups': '/Dashboard/Groups',
    'iONs': '/Dashboard/Controllers',
    "iON's": '/Dashboard/Controllers',
    'Sites on schedule': '/Dashboard/ScheduledActions',
    'Live view enabled sites': '/Dashboard/LiveViewSites',
    'Total live view enabled sites': '/Dashboard/LiveViewSites',
    'Total integrations': '/Dashboard/CCTVIntegrations',
    'AJAX': '/Dashboard/CCTVIntegrations',
    'Dahua': '/Dashboard/CCTVIntegrations',
    'Hikvision': '/Dashboard/CCTVIntegrations',
    'AIBox': '/Dashboard/CCTVIntegrations',
    'Offline AJAX': '/Dashboard/CCTVIntegrations',
    'Offline Hikvision': '/Dashboard/CCTVIntegrations',
    'Offline Dahua': '/Dashboard/CCTVIntegrations',
    'Offline AIBox': '/Dashboard/CCTVIntegrations',
};

const StatCard = ({ title, value, value2, label, hasSecondValue, hasLabel, isLoading, onClick, valueColor, flipValues, tooltip }) => {
    const navigate = useNavigate();
    const icon = ICON_MAP[title];
    const navTarget = NAV_MAP[title];
    const handleClick = onClick ?? (navTarget ? () => navigate(navTarget) : undefined);
    const tooltipClass = tooltip ? `stat-tooltip-${title.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}` : null;

    const mainValue = flipValues ? value2 : value;
    const subValue = flipValues ? value : value2;
    const subLabel = flipValues ? `${subValue} total` : `${subValue} active`;

    return (
        <div
            className={`${classes.card} ${handleClick ? classes.clickable : ''}`}
            onClick={handleClick}
        >
            <div className={classes.header}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <p className={classes.title}>{title}</p>
                    {tooltip && (
                        <>
                            <i className={`pi pi-info-circle ${tooltipClass}`} style={{ color: '#9ca3af', cursor: 'default', fontSize: '12px' }} />
                            <Tooltip target={`.${tooltipClass}`} style={{ maxWidth: '260px' }}>
                                <span>{tooltip}</span>
                            </Tooltip>
                        </>
                    )}
                </div>
                {icon && <img className={classes.icon} src={icon} alt="" />}
            </div>
            {isLoading ? (
                <div className={classes.skeletonBar} style={{ height: '36px', width: '50%', marginTop: '2px' }} />
            ) : (
                <div className={classes.valueRow}>
                    <p className={classes.value} style={valueColor ? { color: valueColor } : undefined}>{mainValue ?? '—'}</p>
                    {hasSecondValue && subValue != null && (
                        <span className={classes.sub}>{subLabel}</span>
                    )}
                    {hasLabel && label != null && (
                        <span className={classes.sub}>{label}</span>
                    )}
                </div>
            )}
        </div>
    );
};

export default StatCard;
